import styled from "styled-components";

interface IAnsweredBionexo {
  budgetSaved?: boolean;
}

export const BionexoAnserewedLine = styled.div<IAnsweredBionexo>`
  position: relative;
  padding: 10px 20px;
  border-radius: 10px;
  border: 2px solid  ${props => props.budgetSaved ? '#BEBEBE' : '#6EE4D9'};

  input[type="radio"]:checked:after {
    background-color:  ${props => props.budgetSaved ? '#BEBEBE' : '#0E4C54'};
    } 
`;

export const BionexoAnserewedFields = styled.div`
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 100px 260px 150px 35px;

    .quantityPackaging {
      .value {
        margin-top: 18px;
      }
    }
`;

export const ObsFieldIcon = styled.div`
      img {
        margin-top: 10px;
      }
`;

export const BionexoAnserewedLabel = styled.div<IAnsweredBionexo>`
  margin-bottom: 10px;

  span {
    position: relative;
    left: 2px;
    font-size: 8px;
    color: #858585;
  }
`;